import { render, staticRenderFns } from "./UnitsMain.vue?vue&type=template&id=2b3dd0e2&scoped=true"
import script from "./UnitsMain.vue?vue&type=script&lang=js"
export * from "./UnitsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3dd0e2",
  null
  
)

export default component.exports